export default "__VITE_ASSET__6eEOi1PY__"